'use client'

import type React from 'react'
import { memo } from 'react'
import DemoLayout from '../_components/demo-layout'

const CloseIcon = memo(() => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
  >
    <title>Close</title>
    <rect
      x="0.625"
      y="0.625"
      width="18.75"
      height="18.75"
      rx="9.375"
      stroke="currentColor"
      strokeWidth="1.25"
    />
    <path
      d="M13.6092 7.07072C13.7969 6.88297 13.7969 6.57857 13.6092 6.39081C13.4214 6.20306 13.117 6.20306 12.9293 6.39081L10 9.32009L7.07072 6.39081C6.88297 6.20306 6.57857 6.20306 6.39081 6.39081C6.20306 6.57857 6.20306 6.88297 6.39081 7.07072L9.32009 10L6.39081 12.9293C6.20306 13.117 6.20306 13.4214 6.39081 13.6092C6.57857 13.7969 6.88297 13.7969 7.07072 13.6092L10 10.6799L12.9293 13.6092C13.117 13.7969 13.4214 13.7969 13.6092 13.6092C13.7969 13.4214 13.7969 13.117 13.6092 12.9293L10.6799 10L13.6092 7.07072Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))
CloseIcon.displayName = 'CloseIcon'

type CloseButtonProps = {
  onClose: () => void
}

const CloseButton = memo(({ onClose }: CloseButtonProps) => (
  <button
    type="button"
    onClick={onClose}
    className="inline-flex items-center justify-center p-0 border-none bg-transparent cursor-pointer hover:opacity-60 duration-150 transition-all text-ink"
    aria-label="デモ画面を閉じる"
  >
    <CloseIcon />
  </button>
))
CloseButton.displayName = 'CloseButton'

type AlertMessageProps = {
  onClose: () => void
}

const AlertMessage = memo(({ onClose }: AlertMessageProps) => {
  return (
    <div
      role="alert"
      className="h-auto lg:h-9 py-2 bg-surface-notice w-full px-6 hidden lg:block"
    >
      <div className="flex justify-between items-center">
        <p className="text-xs pr-1">
          本デモの動作環境は、Google Chrome・Microsoft
          Edge・Safari・Firefoxの各最新版です。
          セキュリティの設定によっては画面が表示されない場合がございます。
        </p>
        <CloseButton onClose={onClose} />
      </div>
    </div>
  )
})
AlertMessage.displayName = 'AlertMessage'

type LayoutProps = {
  children: React.ReactNode
}

const Layout = ({ children }: LayoutProps) => (
  <DemoLayout renderAlert={(onClose) => <AlertMessage onClose={onClose} />}>
    {children}
  </DemoLayout>
)

export default Layout
